import { Component } from '@angular/core';

@Component({
  selector: 'ngx-menus',
  template: `<router-outlet></router-outlet>`,
})
export class MenusComponent {
}
